import React from 'react';
import { IndexRoute, Route } from 'react-router';
import CoreLayout from './layouts/CoreLayout';
import Login from './components/Login';
import TemplateLayout from './layouts/TemplateLayout';
import ContentLayout from './layouts/ContentLayout';
import SavedItemsLayout from './layouts/SavedItemsLayout';
import EditorLayout from './layouts/EditorLayout';
import MainLayout from './layouts/MainLayout';
import ClipperLayout from './layouts/ClipperLayout';
import RunningOrdersLayout from './layouts/RunningOrdersLayout';
import AssetEditor from './components/Editor/';
import TestLayout from './layouts/TestLayout';
import FacebookApiTest from './components/Test/FacebookApiTest';
import TwitterApiTest from './components/Test/TwitterApiTest';
import ContainerTest from './components/Test/ContainerTest/';

export default function getRoutes() {
  return (
    <Route path="/" component={CoreLayout}>
      <Route component={MainLayout}>
        <IndexRoute component={TemplateLayout} />
        <Route path="/assets" component={TemplateLayout} />
        <Route path="/content" component={ContentLayout} />
        <Route path="/runningorders" component={RunningOrdersLayout} />
        <Route path="/saved" components={SavedItemsLayout} />
      </Route>
      <Route path="/editor" component={EditorLayout}>
        <IndexRoute component={AssetEditor} />
        <Route path="/editor/:id" component={AssetEditor} />
      </Route>
      <Route path="/login" component={Login} />
      <Route path="/clipper" component={ClipperLayout}>
        <Route path="/clipper/:user" component={ClipperLayout} />
        <Route path="/clipper/:user/:sessionId" component={ClipperLayout} />
      </Route>
      <Route path="/test" component={TestLayout}>
        <Route path="/test/facebookApi" component={FacebookApiTest} />
        <Route path="/test/twitterApi" component={TwitterApiTest} />
        <Route path="/test/container" component={ContainerTest} />
      </Route>
    </Route>
  );
}



// WEBPACK FOOTER //
// ./app/routes.js